import React, { useContext } from 'react';
import { DatePicker, Flex, Form, Select, Switch } from 'antd';
import dayjs from 'dayjs';

import TaskContext from '@totem/components/ticketing/details/tasks/taskContext';
import BulkTimeEntryContext from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/bulkTimeEntryContext';

const BulkEntryCommonProperties = () => {
  const { resources } = useContext(TaskContext);
  const { setTimeEntryCommon, timeEntryCommon, onUpdateAllTaskBillable } =
    useContext(BulkTimeEntryContext);
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      layout="horizontal"
      initialValues={{
        resourceId: timeEntryCommon.resourceId,
        date: dayjs(timeEntryCommon.date),
        billable: timeEntryCommon.billable,
      }}
    >
      <Flex justify="flex-start" align="middle">
        <div style={{ marginRight: '16px' }}>
          <Form.Item
            label="Resource"
            name="resourceId"
            rules={[{ required: true, message: 'Please select a resource' }]}
          >
            <Select
              placeholder="Select resource"
              value={timeEntryCommon.resourceId}
              onChange={(value) =>
                setTimeEntryCommon({
                  ...timeEntryCommon,
                  resourceId: value,
                })
              }
              style={{ minWidth: 250 }}
            >
              {resources.map((res) => (
                <Select.Option key={res.id} value={res.id}>
                  {res.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div style={{ marginRight: '16px' }}>
          <Form.Item
            label="Date"
            name="date"
            rules={[{ required: true, message: 'Please select date' }]}
          >
            <DatePicker
              onChange={(newValue) =>
                setTimeEntryCommon({
                  ...timeEntryCommon,
                  date: newValue.toISOString(),
                })
              }
            />
          </Form.Item>
        </div>
        <div style={{ marginRight: '16px' }}>
          <Form.Item label="Billable" name="billable" valuePropName="checked">
            <Switch
              value={timeEntryCommon.billable}
              onChange={(checked: boolean) => {
                setTimeEntryCommon({
                  ...timeEntryCommon,
                  billable: checked,
                });

                onUpdateAllTaskBillable(checked);
              }}
            />
          </Form.Item>
        </div>
      </Flex>
    </Form>
  );
};

export default BulkEntryCommonProperties;
